(function () {
    const AJAX_URL = '/ajax/productStoreAmountCompact.php';
    const SITE_ID = 's1';

    let currentPopup = null;
    let isListeningOutside = false;

    function closePopup() {
        if (currentPopup && currentPopup.parentNode) {
            currentPopup.remove();
        }

        currentPopup = null;

        if (isListeningOutside) {
            document.removeEventListener('click', outsideClickListener);
            document.removeEventListener('keydown', escKeyListener);

            isListeningOutside = false;
        }
    }

    function outsideClickListener(event) {
        if (currentPopup && !currentPopup.contains(event.target)) {
            closePopup();
        }
    }

    function escKeyListener(event) {
        if (event.key === 'Escape') {
            closePopup();
        }
    }

    function positionPopup(popup, trigger) {
        const rect = trigger.getBoundingClientRect();

        const popupWidth = popup.offsetWidth;
        const popupHeight = popup.offsetHeight;

        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        let left = rect.left + scrollLeft - 238;
        let top = rect.top + scrollTop;

        if (left < 10) {
            left = rect.right + scrollLeft + 10;
        }

        if (left + popupWidth > window.innerWidth + scrollLeft - 10) {
            left = rect.left + scrollLeft - popupWidth - 10;
        }

        if (top + popupHeight > window.innerHeight + scrollTop - 10) {
            top = rect.bottom + scrollTop - popupHeight - 10;
        }

        if (top < scrollTop + 10) {
            top = rect.bottom + scrollTop + 5;
        }

        popup.style.position = 'absolute';
        popup.style.left = `${Math.max(5, left)}px`;
        popup.style.top = `${Math.max(5, top)}px`;
        popup.style.zIndex = '10000';
    }

    function createLoadingPopup(trigger) {
        const popup = document.createElement('div');

        popup.className = 'custom-store-popup custom-store-popup--font custom-store-popup--loading';
        popup.innerHTML = `
            <div class="spinner"></div>
            <div class="loading-text">Загрузка...</div>
        `;

        document.body.appendChild(popup);
        positionPopup(popup, trigger);

        return popup;
    }

    function parseStoresFromHtml(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const blocks = doc.querySelectorAll('.stores_block');

        const stores = [];

        blocks.forEach((block) => {
            const addrLink = block.querySelector('.stores_text_wrapp a');

            let address = '';

            if (addrLink) {
                address = addrLink.textContent.trim().replace(/\s+/g, ' ');
            }

            if (!address) {
                const textWrap = block.querySelector('.stores_text_wrapp');

                if (textWrap) {
                    address = textWrap.textContent.trim();
                }
            }

            const statusSpan = block.querySelector('.item-stock .value');

            let available = false;
            let quantity = null;

            if (statusSpan) {
                const text = statusSpan.textContent;

                if (text.includes('Есть в наличии')) {
                    available = true;

                    const match = text.match(/\((\d+)\)/);

                    if (match) {
                        quantity = parseInt(match[1], 10);
                    }
                } else if (text.includes('Нет в наличии')) {
                    available = false;
                }
            }

            if (address) {
                stores.push({
                    address,
                    available,
                    quantity,
                });
            }
        });

        return stores;
    }

    function renderPopupContent(stores, productUrl) {
        const fragment = document.createDocumentFragment();
        const title = document.createElement('div');

        title.className = 'custom-store-popup__title';
        title.textContent = 'Наличие';

        fragment.appendChild(title);

        const list = document.createElement('div');

        list.className = 'custom-store-popup__list';

        if (stores.length === 0) {
            const empty = document.createElement('div');

            empty.className = 'custom-store-popup__empty';
            empty.textContent = 'Нет информации о наличии';

            list.appendChild(empty);
        } else {
            stores.forEach((store) => {
                const item = document.createElement('div');

                item.className = 'custom-store-popup__item';

                const address = document.createElement('div');

                address.className = 'custom-store-popup__address';
                address.textContent = store.address;

                item.appendChild(address);

                const status = document.createElement('div');

                status.className = 'custom-store-popup__status';

                if (store.available) {
                    const available = document.createElement('span');

                    available.className = 'custom-store-popup__status-value available';
                    available.textContent = 'В наличии';

                    status.appendChild(available);

                    if (store.quantity !== null) {
                        const quantity = document.createElement('span');

                        quantity.className = 'custom-store-popup__quantity';
                        quantity.textContent = `(${store.quantity})`;

                        status.appendChild(quantity);
                    }
                } else {
                    const unavailable = document.createElement('span');

                    unavailable.className = 'custom-store-popup__status-value not-available';
                    unavailable.textContent = 'Нет в наличии';

                    status.appendChild(unavailable);
                }

                item.appendChild(status);

                list.appendChild(item);
            });
        }

        fragment.appendChild(list);

        const moreBtn = document.createElement('button');

        moreBtn.className = 'custom-store-popup__more';
        moreBtn.textContent = 'Подробнее';

        moreBtn.addEventListener('click', (event) => {
            event.stopPropagation();

            if (productUrl) {
                window.location.href = productUrl;
            } else {
                closePopup();
            }
        });

        fragment.appendChild(moreBtn);

        return fragment;
    }

    async function onStoreTriggerClick(event) {
        const trigger = event.currentTarget;

        event.stopPropagation();

        if (currentPopup) {
            closePopup();
        }

        const elementId = trigger.getAttribute('data-id');
        const storesData = trigger.getAttribute('data-stores');

        if (!elementId) {
            return;
        }

        const storeIds = storesData
            ? storesData
                  .split(',')
                  .map((id) => id.trim())
                  .filter(Boolean)
            : [];

        const loadingPopup = createLoadingPopup(trigger);

        currentPopup = loadingPopup;

        const params = new URLSearchParams();

        params.append('ajax', 'Y');
        params.append('ELEMENT_ID', elementId);
        params.append('FIELDS', '');
        params.append('USER_FIELDS', '');
        params.append('SITE_ID', SITE_ID);

        storeIds.forEach((id) => {
            params.append('STORES[]', id);
        });

        try {
            const response = await fetch(AJAX_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: params.toString(),
            });

            if (!response.ok) {
                closePopup();

                return;
            }

            const html = await response.text();

            if (html.includes('Cannot find') || html.includes('Ошибка')) {
                closePopup();

                return;
            }

            const stores = parseStoresFromHtml(html);
            const productCard = trigger.closest('.catalog-card');
            const productUrl = productCard?.querySelector('.catalog-card__info-title')?.href || '';
            const content = renderPopupContent(stores, productUrl);

            loadingPopup.innerHTML = '';
            loadingPopup.className = 'custom-store-popup custom-store-popup--font';

            loadingPopup.append(content);

            positionPopup(loadingPopup, trigger);

            if (!isListeningOutside) {
                document.addEventListener('click', outsideClickListener);
                document.addEventListener('keydown', escKeyListener);

                isListeningOutside = true;
            }
        } catch {
            closePopup();
        }
    }

    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('.js-store-trigger');

        if (trigger) {
            event.preventDefault();
            event.stopPropagation();

            onStoreTriggerClick({
                currentTarget: trigger,
                stopPropagation: () => {},
            });
        }
    });
})();
